import { useStrings } from "@1js/localization-components";
import {
  Text,
  makeStyles,
  shorthands,
  tokens,
} from "@fluentui/react-components";
import * as React from "react";
import { NoResultsText, NoSavedPromptsTitle } from "./NoResults.strings";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    ...shorthands.padding("20px", "0px"),
    "@media (max-width: 540px)": {
      ...shorthands.padding("16px", "0px"),
    },
  },
  text: {
    color: tokens.colorNeutralForeground2,
    textAlign: "center",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: "28px",
    zIndex: 1,
    "@media (max-width: 540px)": {
      fontSize: "16px",
      lineHeight: "22px",
    },
  },
});

export const NoResults: React.FC<{
  showBookmarkOnly?: boolean;
  hasBookmarkedPrompts?: boolean;
}> = ({ showBookmarkOnly, hasBookmarkedPrompts }) => {
  const styles = useStyles();
  const localizations = useStrings({
    NoResultsText,
    NoSavedPromptsTitle,
  });

  // if bookmark only is toggled, and has bookmark is false, show no saved prompts text
  // if bookmark only is toggled, and has bookmark is true, show no filter results
  // if bookmark only is not toggled, show no filter results
  let displayText = localizations.NoResultsText();
  if (showBookmarkOnly && !hasBookmarkedPrompts) {
    displayText = localizations.NoSavedPromptsTitle();
  }

  return (
    <div className={styles.container}>
      <Text className={styles.text}>{displayText}</Text>
    </div>
  );
};
